import { Organizer } from '@features/organizer';
import { IOrganizer } from '@features/organizer/model/types';
import { useConfirm } from '@shared/hooks/useConfirm';
import { Bin, PencilIcon } from '@shared/assets/icons';
import stylex from '@stylexjs/stylex';
import { FC, useCallback, useState } from 'react';
import { IconButton } from '@shared/ui/icon-button';
import { styles } from './styles';
import { EditOrganizerModal } from '@features/edit-organizer-modal';
import { OrganizerCodeModal } from '@features/organizer-code-modal';
import { colors } from '@shared/tokens/colors.stylex';

interface IOrgnizersProps {
  organizers: IOrganizer[];
  onDelete: (organizer: IOrganizer) => void;
  eventId?: number;
  selectedIds: Set<number>;
  handleCheckboxChange: (id: number) => void;
}

export const OrganizerList: FC<IOrgnizersProps> = ({
  organizers,
  onDelete,
  eventId,
  selectedIds,
  handleCheckboxChange,
}) => {
  const { openConfirmDialog } = useConfirm();

  const [isEditOrganizerModalOpen, setIsEditOrganizerModalOpen] = useState(false);
  const [editingOrganizer, setEditingOrganizer] = useState<IOrganizer | undefined>();

  const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);
  const [codeOrganizer, setCodeOrganizer] = useState<IOrganizer | undefined>();

  const handleEditClick = useCallback((org: IOrganizer) => {
    setEditingOrganizer(org);
    setIsEditOrganizerModalOpen(true);
  }, []);

  const handleCloseEditOrganizerModal = useCallback(() => {
    setIsEditOrganizerModalOpen(false);
    setEditingOrganizer(undefined);
  }, []);

  const handleGetCode = useCallback((organizer: IOrganizer) => {
    setCodeOrganizer(organizer);
    setIsCodeModalOpen(true);
  }, []);

  const handleDeleteOrganizer = useCallback(
    async (organizer: IOrganizer) => {
      if (
        await openConfirmDialog(
          `Удалить организатора ${organizer.firstName} ${organizer.lastName} ?`,
          'Подтвердите удаление',
          'Удалить'
        )
      ) {
        onDelete(organizer);
      }
    },
    [openConfirmDialog, onDelete]
  );
  const handleCloseCodeModal = useCallback(() => {
    setIsCodeModalOpen(false);
    setCodeOrganizer(undefined);
  }, []);

  return (
    <>
      <div {...stylex.props(styles.container)}>
        {organizers.map((organizer) => (
          <Organizer
            isChecked={selectedIds.has(organizer.id!)}
            handleCheckboxChange={() => handleCheckboxChange(organizer.id!)}
            actions={
              <>
                <div {...stylex.props(styles.iconContainer)}>
                  <IconButton
                    icon={<PencilIcon color={colors.tertiaryIcon} width="16" height="16" />}
                    onClick={() => handleEditClick(organizer)}
                  />
                </div>
                <div {...stylex.props(styles.iconContainer)}>
                  <IconButton icon={<Bin />} onClick={() => handleDeleteOrganizer(organizer)} />
                </div>
              </>
            }
            key={organizer.id}
            organizer={organizer}
            onGetCode={handleGetCode}
          />
        ))}
      </div>
      <EditOrganizerModal
        isOpen={isEditOrganizerModalOpen}
        onClose={handleCloseEditOrganizerModal}
        organizer={editingOrganizer}
      />
      <OrganizerCodeModal
        isOpen={isCodeModalOpen}
        onClose={handleCloseCodeModal}
        organizer={codeOrganizer}
        eventId={eventId}
      />
    </>
  );
};
